import { render, staticRenderFns } from "./GenericTask.vue?vue&type=template&id=4bc7d634&"
import script from "./GenericTask.vue?vue&type=script&lang=js&"
export * from "./GenericTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports